module.exports = __webpack_public_path__ + "img/grihachikitsa.749b7c19.png";